/**
 * React bootstrap. Bridges the HTML entrypoint to the React component tree.
 *
 * Runtime split: inside a Tauri webview we render the Meridian app (<App />).
 * In a plain browser (the public suron.io build) we render the Chapter 1
 * landing (<Chapter1 />).
 *
 * The HMR guard exists because Tauri's WKWebView on iOS doesn't provide
 * import.meta.hot, and accessing it without a guard crashes silently.
 * Reusing the root across hot updates preserves component state.
 */
import { createRoot } from "react-dom/client";
import { App } from "../App";
import { Chapter1 } from "../landing/Chapter1";

const isTauri =
  typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;

const hmr = import.meta.hot;
const root = hmr
  ? (hmr.data.root ??= createRoot(document.getElementById("root")!))
  : createRoot(document.getElementById("root")!);

root.render(isTauri ? <App /> : <Chapter1 />);
